<!--container-->
<div class="ds-pt-2xl ds-pb-3xl lg:!ds-pt-3xl lg:!ds-pb-4xl">
  <!--background-container-->
  <div
    class="
      ds-max-w-[1920px] ds-mx-auto ds-pt-xl ds-pb-2xl
      sm:!ds-py-2xl
      md:!ds-pt-2xl md:!ds-pb-3xl
    "
    [class.ds-bg-background-white]="
      type === 'white-blue' || type === 'white-grey'
    "
    [class.ds-bg-background-blue]="type === 'blue-white'"
    [class.ds-bg-background-grey]="type === 'grey-white'"
  >
    <div class="ds-mx-auto ds-px-lg lg:!ds-px-3xl ds-max-w-[760px]">
      <ng-content select="[carouselElementHeading]"></ng-content>
    </div>

    <!--module-container-wide-->
    <div>
      <ui-carousel type="max-3-slides">
        <ui-carousel-slide *ngFor="let slide of slides">
          <ng-container
            [ngTemplateOutlet]="slide.templateRef!"
            [ngTemplateOutletContext]="{ type }"
          ></ng-container>
        </ui-carousel-slide>
      </ui-carousel>
    </div>
  </div>
</div>
